export const EMPTY_ERROR = { field: '', error: '' }

export const getFieldError = (canValidate, currentError, fieldName, fallbackMessage = 'pleaseCompleteThisField') => {
  if (canValidate) {
    return currentError.field === fieldName ? currentError : EMPTY_ERROR
  }
  return { field: fieldName, error: fallbackMessage }
}

export const cleanLegacySelection = (id, legacyValue) => {
  const hasLegacy = id.includes(legacyValue)
  const numericSelections = id.filter((val) => typeof val === 'number')
  const hasOtherOptions = numericSelections.length > 0

  if (!(hasLegacy && hasOtherOptions)) {
    return [...id]
  }

  const lastSelected = id.at(-1)
  if (lastSelected === legacyValue) {
    return [legacyValue]
  }
  return id.filter((val) => val !== legacyValue)
}

export const cleanMutuallyExclusivePairSelection = (id, firstValue, secondValue) => {
  const hasFirst = id.includes(firstValue)
  const hasSecond = id.includes(secondValue)

  if (!(hasFirst && hasSecond)) {
    return [...id]
  }

  const lastSelected = id.at(-1)
  if (lastSelected === firstValue) {
    return id.filter((val) => val !== secondValue)
  }
  return id.filter((val) => val !== firstValue)
}
